(function () {
  if (window.__staudHomeLoaded) return;
  window.__staudHomeLoaded = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-staud-scroll]');
    if (!button) return;
    var section = button.closest('.st-products');
    var track = section && section.querySelector('[data-staud-track]');
    if (!track) return;
    var direction = Number(button.getAttribute('data-staud-scroll')) || 1;
    track.scrollBy({ left: track.clientWidth * 0.82 * direction, behavior: 'smooth' });
  });
})();
